/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Receivelist_Custom1Inputs */

const id_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi berbasis topik khusus`)
};

const ms_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan berasaskan topik tersuai`)
};

const da_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brugerdefinerede emnebaserede notifikationer`)
};

const de_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte themenbasierte Benachrichtigungen`)
};

const en_us2_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom topic-based notifications`)
};

const es_es2_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones personalizadas basadas en temas`)
};

const es_mx2_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones personalizadas basadas en temas`)
};

const fil_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga custom na notipikasyon batay sa paksa`)
};

const fr_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications personnalisées par sujet`)
};

const it_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche personalizzate basate su argomenti`)
};

const hu_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyéni témakör alapú értesítések`)
};

const nl_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangepaste onderwerpgebaseerde meldingen`)
};

const no_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egendefinerte emnebaserte varsler`)
};

const pl_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niestandardowe powiadomienia tematyczne`)
};

const pt_br2_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações personalizadas baseadas em tópicos`)
};

const pt_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações personalizadas baseadas em tópicos`)
};

const ro_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificări personalizate pe bază de subiecte`)
};

const fi_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mukautetut aihekohtaiset ilmoitukset`)
};

const sv_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassade ämnesbaserade notiser`)
};

const vi_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo tùy chỉnh theo chủ đề`)
};

const tr_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel konu tabanlı bildirimler`)
};

const cs_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastní oznámení na základě témat`)
};

const bg_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Персонализирани известия на тематична основа`)
};

const ru_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательские уведомления по темам`)
};

const uk_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення на основі користувацьких тем`)
};

const ar_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إشعارات مخصصة قائمة على الموضوعات`)
};

const hi_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कस्टम विषय-आधारित सूचनाएँ`)
};

const th_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือนแบบกำหนดเองตามหัวข้อ`)
};

const ja_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタムトピックベースの通知`)
};

const zh_cn2_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于主题的自定义通知`)
};

const zh_hant1_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基於主題的自訂通知`)
};

const ko_notifications_receivelist_custom1 = /** @type {(inputs: Notifications_Receivelist_Custom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`맞춤 주제 기반 알림`)
};

/**
* | output |
* | --- |
* | "Custom topic-based notifications" |
*
* @param {Notifications_Receivelist_Custom1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_receivelist_custom1 = /** @type {((inputs?: Notifications_Receivelist_Custom1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Receivelist_Custom1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_receivelist_custom1(inputs)
	if (locale === "ms") return ms_notifications_receivelist_custom1(inputs)
	if (locale === "da") return da_notifications_receivelist_custom1(inputs)
	if (locale === "de") return de_notifications_receivelist_custom1(inputs)
	if (locale === "en-US") return en_us2_notifications_receivelist_custom1(inputs)
	if (locale === "es-ES") return es_es2_notifications_receivelist_custom1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_receivelist_custom1(inputs)
	if (locale === "fil") return fil_notifications_receivelist_custom1(inputs)
	if (locale === "fr") return fr_notifications_receivelist_custom1(inputs)
	if (locale === "it") return it_notifications_receivelist_custom1(inputs)
	if (locale === "hu") return hu_notifications_receivelist_custom1(inputs)
	if (locale === "nl") return nl_notifications_receivelist_custom1(inputs)
	if (locale === "no") return no_notifications_receivelist_custom1(inputs)
	if (locale === "pl") return pl_notifications_receivelist_custom1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_receivelist_custom1(inputs)
	if (locale === "pt") return pt_notifications_receivelist_custom1(inputs)
	if (locale === "ro") return ro_notifications_receivelist_custom1(inputs)
	if (locale === "fi") return fi_notifications_receivelist_custom1(inputs)
	if (locale === "sv") return sv_notifications_receivelist_custom1(inputs)
	if (locale === "vi") return vi_notifications_receivelist_custom1(inputs)
	if (locale === "tr") return tr_notifications_receivelist_custom1(inputs)
	if (locale === "cs") return cs_notifications_receivelist_custom1(inputs)
	if (locale === "bg") return bg_notifications_receivelist_custom1(inputs)
	if (locale === "ru") return ru_notifications_receivelist_custom1(inputs)
	if (locale === "uk") return uk_notifications_receivelist_custom1(inputs)
	if (locale === "ar") return ar_notifications_receivelist_custom1(inputs)
	if (locale === "hi") return hi_notifications_receivelist_custom1(inputs)
	if (locale === "th") return th_notifications_receivelist_custom1(inputs)
	if (locale === "ja") return ja_notifications_receivelist_custom1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_receivelist_custom1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_receivelist_custom1(inputs)
	return ko_notifications_receivelist_custom1(inputs)
});
export { notifications_receivelist_custom1 as "notifications.receiveList.custom" }